.eventCard {
	display: flex;
	flex-direction: column;
	gap: 0.18rem;
	padding: 0.35rem 0.45rem;
	background: #ffffff;
	border: 1px solid #e5e7eb;
	border-left: 3px solid #82bc44;
	border-radius: 0.4rem;
	box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
	transition:
		transform 0.12s ease,
		box-shadow 0.12s ease,
		border-color 0.12s ease;
	min-width: 0;
}

.eventCard:hover {
	transform: translateY(-1px);
	box-shadow: 0 4px 10px rgba(15, 23, 42, 0.08);
}

.eventTitle {
	font-size: 0.78rem;
	font-weight: 700;
	color: #111827;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	line-height: 1.15;
}

.eventSubtitle {
	font-size: 0.68rem;
	color: #6b7280;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	line-height: 1.2;
}

.eventBadges {
	display: flex;
	flex-wrap: wrap;
	gap: 0.2rem;
	margin-top: 0.1rem;
}

@media (max-width: 768px) {
	.eventCard {
		padding: 0.25rem 0.3rem;
		border-left-width: 2px;
		border-radius: 0.3rem;
	}
	.eventTitle {
		font-size: 0.68rem;
	}
	.eventSubtitle {
		display: none;
	}
	.eventBadges {
		display: none;
	}
}
